<template lang="html">
  <div class="i-header">
    <div @click.stop="leftClick" class="i-header-left">
      <slot name="left"></slot>
    </div>
    <div class="i-header-title">
      <slot name="title">{{title}}</slot>
    </div>
    <div @click.stop="rightClick" class="i-header-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'i-header',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    leftClick() {
      this.$emit('leftClick');
    },
    rightClick() {
      this.$emit('rightClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.i-header {
  height: 44px;
  line-height: 44px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  .i-header-left {
    flex: .4;
    font-size: 13px;
    color: #666;
    text-align: left;
  }
  .i-header-title {
    flex: 1.2;
    font-size: 17px;
    color: #222;
    font-weight: bold;
    text-align: center;
  }
  .i-header-right {
    flex: .4;
    font-size: 13px;
    color: #666;
    text-align: right;
  }
}
</style>
